export const hourlyCalendar = {
  title: "Stundenkalender",
  navSubtitle: "Stundenweise Buchung für Ihr Hotel",
  hotel: "Hotel",
  rooms: "Zimmer",
  roomsAbbr: "Zimmer",
  noDisp: "k. A.",
  footer: {
    free: "{n} frei",
    occupied: "{n} belegt",
    cleaning: "{n} in Reinigung",
    timezone: "Zeitzone: {tz}",
  },
  today: "Heute",
  prevDay: "Vorheriger Tag",
  nextDay: "Nächster Tag",
  newStay: "Neuer Aufenthalt",
  settingsBtn: "Einstellungen für stundenweise Buchung",
  retry: "Erneut versuchen",
  dragHint: "Über ein Zimmer ziehen, um einen Aufenthalt anzulegen",
  groupFree: "{free} von {total} frei",
  zoom: { label: "Zoom", compact: "Kompakt", normal: "Normal", wide: "Breit" },
  duration: { min: "{n} Min.", h: "{n} Std.", hmin: "{h} Std. {m} Min." },
  kpi: {
    free: "Jetzt frei",
    occupied: "Belegt",
    cleaning: "In Reinigung",
    arrivals: "Ankunft in 1 Std.",
    overdueAlert: "1 Zimmer hat die Check-out-Zeit überschritten | {n} Zimmer haben die Check-out-Zeit überschritten",
  },
  state: {
    free: "Frei",
    freeNext: "Frei · nächster {time}",
    soon: "Ankunft um {time}",
    occupied: "Belegt",
    occupiedLeft: "Belegt · noch {time}",
    overdue: "Überfällig {time}",
    due: "Wartet auf Check-in",
    cleaning: "Reinigung · {time}",
    closed: "Geschlossen",
    maintenance: "Außer Betrieb",
  },
  status: {
    booked: "Gebucht",
    in_house: "Läuft",
    checked_out: "Beendet",
    cancelled: "Storniert",
    no_show: "No-Show",
  },
  block: {
    noName: "Ohne Namen",
    blocked: "Gesperrt",
    night: "Übernachtung",
    closed: "Geschlossen",
    maintenance: "Außer Betrieb",
    left: "noch {time}",
  },
  legend: {
    booked: "Gebucht",
    inHouse: "Läuft",
    overdue: "Überfällig",
    cleaning: "Reinigung",
    night: "Übernachtungsbuchung",
    closed: "Geschlossen",
  },
  rangeMenu: {
    create: "Aufenthalt anlegen",
    createSub: "Im ausgewählten Zeitraum",
    block: "Diese Zeit sperren",
    blockSub: "Das Zimmer wird in diesem Zeitraum nicht verkauft",
    closeDay: "Zimmer den ganzen Tag schließen",
    closeDaySub: "Dieses Zimmer wird an diesem Tag nicht verkauft",
  },
  blockMenu: {
    editReason: "Grund ändern",
    editReasonSub: "Er wird im Kalender angezeigt",
    remove: "Sperre aufheben",
    removeSub: "Das Zimmer wird wieder verkauft",
  },
  blockModal: {
    titleRange: "Diese Zeit sperren",
    titleDay: "Zimmer schließen",
    titleEdit: "Sperrgrund",
    msgRange: "{room} wird von {range} nicht verkauft.",
    msgDay: "{room} wird am {date} nicht verkauft.",
    msgDayRest: "{room} wird für den Rest des Tages nicht verkauft (ab {time}).",
    msgEdit: "{room}",
    reasonLabel: "Grund",
    reasonHint: "(wird im Kalender angezeigt)",
    placeholder: "Wartung, Eigennutzung…",
    cancel: "Abbrechen",
    block: "Sperren",
    save: "Speichern",
    presetMaintenance: "Wartung",
    presetOwner: "Eigennutzung",
    presetRepair: "Renovierung",
    presetDeepClean: "Grundreinigung",
    presetClosed: "Geschlossen",
  },
  drawer: {
    close: "Schließen",
    closeBtn: "Schließen",
    newTitle: "Neuer Aufenthalt",
    newPill: "Neu",
    when: "Wann",
    room: "Zimmer",
    start: "Check-in",
    end: "Check-out",
    nextDay: "Folgetag",
    duration: "Dauer",
    other: "Andere",
    free: "Zimmer zu dieser Zeit frei",
    freeWithCleaning: "Frei · {n} Min werden für die Reinigung nach dem Auszug freigehalten",
    freeWillClose: "Frei · danach bleibt es bis {hour} geschlossen",
    busy: "Belegt von {from} bis {to}",
    busyClosed: "Geschlossen von {from} bis {to}",
    busyMaintenance: "Zimmer außer Betrieb",
    guest: "Gast",
    guestName: "Name",
    phone: "Telefon",
    optional: "Optional",
    guests: "Personen",
    charge: "Zahlung",
    price: "Preis",
    method: "Zahlungsmethode",
    methods: { cash: "Bar", card: "Karte", transfer: "Überweisung", other: "Andere" },
    paid: "Bezahlt",
    paidHint: "Du hast das Geld für diesen Aufenthalt bereits.",
    notes: "Notizen",
    notesPh: "Kennzeichen, Wünsche, alles Nützliche",
    guestTitle: "Gästeregistrierung",
    sendCheckin: "Check-in-Link senden",
    sendCheckinHint: "Er wird beim Speichern an das Telefon des Gastes gesendet.",
    sendCheckinNoPhone: "Fügen Sie die Telefonnummer des Gastes hinzu, um den Check-in senden zu können.",
    doCheckin: "Check-in durchführen",
    edit: "Bearbeiten",
    client: "Gast",
    paidYes: "Bezahlt",
    paidNo: "Nicht bezahlt",
    markPaid: "Als bezahlt markieren",
    doCheckinHint: "Öffnen Sie ihn auf dem Telefon des Gastes oder teilen Sie den Link: Vorname, Nachname und Dokument, auf Wunsch mit Scan.",
    copyLink: "Link kopieren",
    copied: "Link kopiert",
    checkinDone: "Check-in erledigt · {n} Gast registriert | Check-in erledigt · {n} Gäste registriert",
    checkinErrors: {
      no_reservation: "Aktivieren Sie in den Einstellungen „Aufenthalte als Buchungen erfassen“, um den Check-in anfordern zu können.",
      no_phone: "Fügen Sie die Telefonnummer des Gastes hinzu, um ihn senden zu können.",
      send_failed: "Der Versand ist fehlgeschlagen. Kopieren Sie den Link und teilen Sie ihn selbst.",
      not_requested: "Der Versand ist fehlgeschlagen. Kopieren Sie den Link und teilen Sie ihn selbst.",
    },
    checkinSent: "Check-in gesendet",
    sendCheckinFailed: "Der Check-in konnte nicht gesendet werden. Prüfen Sie die Telefonnummer des Gastes.",
    save: "Speichern",
    saveAndIn: "Speichern und einchecken",
    saveChanges: "Änderungen speichern",
    checkIn: "Einchecken",
    checkOut: "Auschecken",
    extend30: "30 Min.",
    extend60: "1 Std.",
    extendOther: "Andere",
    extendHow: "Verlängern",
    extendApply: "Verlängern",
    cancelBtn: "Abbrechen",
    checkOutNotYet: "Auschecken ist erst möglich, wenn der Aufenthalt begonnen hat",
    confirmEarlyOutTitle: "Der Aufenthalt hat noch nicht begonnen",
    confirmEarlyOut: "Dieser Aufenthalt beginnt später. Ein Check-out jetzt schließt ihn ab und gibt das Zimmer frei. Wenn der Gast nie gekommen ist, nutzen Sie stattdessen „No-Show“.",
    noShow: "No-Show",
    cancelStay: "Aufenthalt stornieren",
    keep: "Zurück",
    confirmCancel: "Der Aufenthalt wird storniert und das Zimmer ist zu dieser Zeit frei. Das kann nicht rückgängig gemacht werden.",
    confirmNoShow: "Der Zeitraum kann wieder verkauft werden. Es wird festgehalten, dass der Gast nicht gekommen ist.",
    confirmNoShowInHouse: "Der Gast war eingecheckt, ist aber nie aufs Zimmer gegangen: Der Check-in wird rückgängig gemacht und der Zeitraum ist wieder frei.",
    confirmCancelInHouse: "Der Gast war eingecheckt: Der Check-in wird rückgängig gemacht, der Aufenthalt storniert und das Zimmer freigegeben. Das kann nicht rückgängig gemacht werden.",
    confirmNoShowTitle: "Ist der Gast nicht erschienen?",
    confirmCancelTitle: "Diesen Aufenthalt stornieren?",
    remaining: "noch {time}",
    overdue: "{time} über die Check-out-Zeit",
    startsIn: "Beginnt in {time}",
    waiting: "Die Zeit hat begonnen: wartet auf Check-in",
    closedInfo: "Abgeschlossener Aufenthalt: Nur Zahlung und Notizen können geändert werden.",
    night: {
      title: "Übernachtungsbuchung",
      dates: "Von {from} bis {to}",
      code: "Code",
      channel: "Channel",
      hint: "Übernachtungsbuchungen werden im Hotelkalender verwaltet. Sie werden hier angezeigt, damit sich kein stundenweiser Aufenthalt mit ihnen überschneidet.",
      open: "Zum Hotelkalender",
    },
  },
  settings: {
    title: "Stundenweise Buchung",
    enable: "Stundenweise vermieten",
    subtitle: "Wie dieses Hotel stundenweise verkauft",
    offTitle: "Wenn Sie es ausschalten",
    offBody: "Der Stundenkalender ist dann nicht mehr verfügbar und das Hotel arbeitet wie zuvor. Es wird nichts gelöscht.",
    offBodyStays: "Sie haben {n} bevorstehende Stundenaufenthalte: Sie werden nicht gelöscht, sind aber erst wieder sichtbar, wenn Sie es erneut einschalten.",
    enabledOn: "An: Der Stundenkalender wird genutzt",
    enabledOff: "Aus",
    requirements: "Voraussetzungen",
    req: {
      rooms: "Zimmer angelegt ({n})",
      channels: "Keine Vertriebskanäle verbunden",
      ical: "Keine synchronisierten iCal-Kalender",
      web: "Online-Buchung ausgeschaltet",
      nights: "{n} bevorstehende Übernachtungsbuchungen: Sie erscheinen im Kalender und sperren ihre Zimmer",
    },
    reqWhy: "Channels, iCal und Ihre Website verkaufen Nächte und kennen keine Stunden: Ist eines davon aktiv, könnte dasselbe Zimmer doppelt verkauft werden.",
    cleaning: "Reinigung zwischen Aufenthalten",
    cleaningHint: "Wird nach jedem Check-out automatisch reserviert.",
    pending: "Reinigung ausstehend",
    pendingHint: "Wenn ein Gast geht, bleibt das Zimmer so lange als „zu reinigen“ markiert — in der Reinigung und in der App. Es blockiert den Verkauf NICHT: kommt vorher jemand, wird dann gereinigt.",
    none: "keine",
    minutes: "Min.",
    hours: "Std.",
    closeTitle: "Bis zur Öffnungszeit schließen",
    closeHint: "Für den Fall, dass nicht sofort gereinigt wird: das Zimmer bleibt geschlossen und niemand kann es verkaufen, bis du öffnest.",
    closeAfterStay: "Nach einem Aufenthalt das Zimmer geschlossen lassen",
    closeAfterStayHint: "Es schließt von selbst bis zur Öffnungszeit am nächsten Tag. Reinigst du früher, drücke „Ist sauber“ und es geht sofort wieder in den Verkauf.",
    afterTitle: "Nach jedem Aufenthalt",
    afterHint: "Wie lange das Zimmer nicht verkauft wird, wenn ein Gast auszieht.",
    untilOpening: "Bis zur Öffnung",
    reopenHour: "Öffnungszeit für den Verkauf",
    reopenNote: "Schmutzige Zimmer gehen um {hour} wieder in den Verkauf.",
    markClean: "Ist sauber",
    markCleanHint: "Öffnet das Zimmer jetzt, ohne auf die Öffnungszeit zu warten.",
    closeThisStay: "Das Zimmer am Ende geschlossen lassen",
    closeThisStayHint: "Nicht verkäuflich bis {hour}. Die Uhrzeit änderst du in den Einstellungen.",
    dayStart: "Beginn des Kalendertags",
    dayRange: "von {from} bis {from} des Folgetags",
    dayStartHint: "Wählen Sie Ihre ruhigste Stunde, damit die Nacht am Stück angezeigt wird.",
    quickHours: "Schnelldauern",
    quickHoursHint: "Werden beim Anlegen eines Aufenthalts als Kurzwahl angezeigt (bis zu 6).",
    guestTitle: "Gästeregistrierung",
    asReservation: "Aufenthalte als Buchungen erfassen",
    asReservationHint: "Jeder Aufenthalt erzeugt seine Buchung: So erscheint das Geld in deinen Berichten und du kannst Check-in und Gästemeldung anfordern. Ausgeschaltet zählen Stundenverkäufe nicht zu deinem Umsatz.",
    checkinDefault: "Check-in standardmäßig anfordern",
    checkinDefaultHint: "Der Schalter im Formular des Aufenthalts ist dann bereits aktiviert.",
    guestHint: "Diese Buchungen erhalten nicht die Nachrichten für Übernachtungen (Willkommen, Anreise, Check-out oder Bewertung): Der Check-in-Link wird gesendet, wenn Sie ihn anfordern.",
    save: "Einstellungen speichern",
    saved: "Einstellungen gespeichert",
  },
  empty: {
    eyebrow: "Stundenweise Buchung",
    title: "Vermieten Sie Ihre Zimmer stundenweise",
    body: "Ein Kalender für Motels und Hotels mit Kurzaufenthalten: Sehen Sie jedes Zimmer Minute für Minute, legen Sie Aufenthalte per Ziehen an, und die Reinigung dazwischen wird automatisch reserviert.",
    point1: "Echtzeitstatus für jedes Zimmer",
    point2: "Aufenthalte per Ziehen anlegen, verschieben oder verlängern",
    point3: "Automatische Reinigung zwischen Aufenthalten",
    cta: "Stundenweise Buchung einschalten",
    ctaBlocked: "Erfüllen Sie die Voraussetzungen zum Einschalten",
    noHotelsTitle: "Sie haben noch kein Hotel",
    noHotels: "Stundenweise Buchung funktioniert mit Unterkünften vom Typ Hotel, für die Zimmer angelegt sind.",
  },
  guide: {
    open: "So funktioniert es",
    title: "So funktioniert der Stundenkalender",
    subtitle: "Das Wichtigste in einer Minute: Aufenthalte anlegen, Gäste ein- und auschecken und Zimmer schließen, die Sie nicht verkaufen.",
    createTitle: "Aufenthalt anlegen",
    createBody: "Ziehen Sie entlang der Zeile des Zimmers, von der Check-in-Zeit bis zur Check-out-Zeit. Sie können auch auf „Neuer Aufenthalt“ klicken und die Zeiten selbst eingeben.",
    moveTitle: "Verschieben und verlängern",
    moveBody: "Ziehen Sie den Balken, um Zeit oder Zimmer zu ändern. Ziehen Sie am rechten Rand, um den Aufenthalt zu verlängern oder zu verkürzen. Ist der Zeitraum belegt, lässt der Kalender das Ablegen nicht zu.",
    checkinTitle: "Check-in und Check-out",
    checkinBody: "Öffnen Sie den Aufenthalt und checken Sie den Gast bei der Ankunft ein und bei der Abreise aus. Bei Überschreitung wird der Balken rot und zeigt die zusätzlichen Minuten.",
    cleaningTitle: "Reinigung zwischen Aufenthalten",
    cleaningBody: "Nach jedem Check-out reserviert der Kalender die von Ihnen eingestellte Reinigungszeit. In diesem Zeitfenster kann niemand einchecken.",
    blockTitle: "Zeitfenster sperren oder Zimmer schließen",
    blockBody: "Wählen Sie einen Zeitraum und dann „Diese Zeit sperren“ oder „Zimmer den ganzen Tag schließen“, wenn Sie es an diesem Tag nicht verkaufen. Klicken Sie auf die Sperre, um ihren Grund zu ändern oder sie aufzuheben.",
    settingsTitle: "Einstellungen",
    settingsBody: "Über das Zahnrad legen Sie die Reinigungszeit fest, die Stunde, zu der der Kalendertag beginnt, und die Schnelldauern, die Sie beim Anlegen eines Aufenthalts sehen.",
    colorsTitle: "Was die Farben bedeuten",
    colors: {
      booked: "Angelegt, der Gast hat noch nicht eingecheckt",
      inHouse: "Der Gast ist im Zimmer",
      overdue: "Check-out-Zeit überschritten",
      cleaning: "Für die Reinigung reservierte Zeit",
      night: "Kommt aus dem Übernachtungskalender",
      closed: "Von Hand gesperrt oder geschlossen",
    },
    otasTitle: "Übernachtungsbuchungen und Channels",
    otasBody: "Übernachtungsbuchungen erscheinen hier, damit Sie sehen, welche Zimmer belegt sind, verwaltet werden sie aber im Hotelkalender. Solange Sie stundenweise verkaufen, wird diese Unterkunft nicht mit OTAs verbunden.",
    gotIt: "Verstanden",
  },
  toasts: {
    created: "Aufenthalt angelegt",
    checkedIn: "Check-in erfasst",
    checkedOut: "Check-out erfasst · Reinigung gestartet",
    updated: "Änderungen gespeichert",
    extended: "Aufenthalt verlängert",
    cancelled: "Aufenthalt storniert",
    noShow: "Als No-Show markiert",
    moved: "Aufenthalt verschoben",
    resized: "Dauer aktualisiert",
    activated: "Stundenweise Buchung eingeschaltet",
    blocked: "Zeit gesperrt",
    blockUpdated: "Grund aktualisiert",
    blockRemoved: "Sperre aufgehoben",
    loadError: "Der Stundenkalender konnte nicht geladen werden",
    error: "Speichern nicht möglich. Bitte versuchen Sie es erneut.",
  },
  errors: {
    room_busy: "Das Zimmer ist von {from} bis {to} belegt",
    hourly_disabled: "Stundenweise Buchung ist für dieses Hotel nicht eingeschaltet.",
    room_maintenance: "Dieses Zimmer ist außer Betrieb.",
    room_not_found: "Dieses Zimmer gehört nicht zu diesem Hotel.",
    invalid_duration: "Die Dauer muss zwischen 30 Minuten und 48 Stunden liegen.",
    invalid_start: "Die Check-in-Zeit ist ungültig.",
    stay_closed: "Dieser Aufenthalt ist bereits abgeschlossen und kann nicht verschoben werden.",
    invalid_status: "Diese Aktion ist im aktuellen Status des Aufenthalts nicht verfügbar.",
    requirements_not_met: "Dieses Hotel erfüllt die Voraussetzungen für stundenweise Buchung noch nicht.",
    not_found: "Das konnten wir nicht finden. Bitte laden Sie die Seite neu.",
    generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  },
};
